import { render, staticRenderFns } from "./HistoryCaptain.vue?vue&type=template&id=c1035f18"
import script from "./HistoryCaptain.vue?vue&type=script&lang=js"
export * from "./HistoryCaptain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports